import { easings } from 'constants/easings'

/**
 * Transitions
 *
 * Named transitions defined in a plain object
 *
 * For use with the following CSS properties:
 *
 *     transitions
 *
 * @see https://system-ui.com/theme
 */

export const transitions = {
  duration: ['100ms', '200ms', '300ms', '400ms', '500ms'],
  timing: {
    ...easings,
  },
}
